import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Truck } from 'src/app/models/truck';
import { environment } from 'src/environments/environment';

const { API_URL } = environment

@Injectable({
  providedIn: 'root'
})
export class TruckService {

  constructor(
    private httpClient: HttpClient,
  ) { 
  }

  async getTrucksFleetBooklet(token: string): Promise<Truck[]> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.httpClient.get<Truck[]>(`${API_URL}/profiles/trucks`, { headers }).toPromise();
  }

  async sendNumberPlate(token: string, numberPlate: string): Promise<any> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.httpClient.post<any>(`${API_URL}/profiles/truck/number-plate`, numberPlate, { headers }).toPromise();
  }

  async sendTruckData(token: string, truck: Truck): Promise<Truck> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.httpClient.post<Truck>(`${API_URL}/profiles/truck`, truck, { headers }).toPromise();
  }

  async updateTruckData(token: string, id: number | string, truck: Truck): Promise<Truck> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.httpClient.put<Truck>(`${API_URL}/profiles/truck/${id}`, truck, { headers }).toPromise();
  }

  async deleteTruck(token: string, id: number | string): Promise<Truck> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.httpClient.delete<Truck>(`${API_URL}/profiles/truck/${id}`, { headers }).toPromise();
  }

  async getRouteOwnerTrucks(token: string, id: number | string): Promise<Truck[]> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.httpClient.get<Truck[]>(`${API_URL}/profiles/by-owner/${id}`, { headers }).toPromise();
  }

}
